import {environment} from '../environment/environment';
import {apiRoutes} from '../enumerator/api-routes.enum';
import * as moment from 'moment';

export default class AuthentificationService {

    constructor() {

    }

    /**
     * -------------------
     * getAnonymousToken
     * -------------------
     * @param: null
     * @returns: void
     * @description
     * Get un token anonyme à keycloak
     */
    static getAnonymousToken = function () {
        return new Promise(async (resolve, reject) => {
            const bodyParams = {
                grant_type: 'client_credentials',
                client_id: environment.clientAuth,
                client_secret: environment.clientAuthSecret
            };

            $.ajax({
                method: "POST",
                url: (`${environment.url_auth}${apiRoutes.KEYCLOAK.token}`),
                data: bodyParams,
                headers: {
                    Authorization: btoa(Theme.ip_address) + 'myBusIo',
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            }).success((result) => {
                if (result.access_token) {
                    const dataToken = {
                        ...result,
                        expirationDate: moment().add(result.expires_in, 'seconds').format()
                    };
                    window.localStorage.setItem( 'keycloak_token', dataToken);
                    resolve(dataToken);
                }
            }).catch(error => {
                reject(error);
            });
        });
    }
}